import { useEffect, useState } from "react";
import FileNotFound from "../../error/file-not-found";
import FooterLayout from "../../footer/footer-layout";
import { useTranslation } from "react-i18next";
import BlogDetailsHero from "./blogDetailsHero";
import { Box, Stack, useTheme } from "@mui/material";
import BlogDetailsBody from "./blogDetailsBody";
import BlogAuthor from "./blogAuthor";
import BlogCallToAction from "./blogCallToAction";
import NavigationLayout from "../../navigation/navigation-layout";
import BlogRecommendations from "./blogRecommendations";
import blogListData from '../../../data/blogs/en/blogs.json';
import SectionLayout from "../../../layouts/section-layout";

const blogLocales = "blogs";

const BlogDetailsLayout = ({
    id
}) => {
    const {t} = useTranslation();
    const theme = useTheme();

    const [data, setData] = useState(null);
    const [error, setError] = useState(false);
    
    useEffect(() => {
        if(id >= 1 && id <= blogListData.length){
            const jsonFileName = blogListData[id - 1].file;

            import(`../../../data/blogs/en/${jsonFileName}.json`)
            .then((module) => setData(module.default))
            .catch((err) => setError(true));
        }
        else{
            setError(true);
        }
    }, [id]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <NavigationLayout />

            <SectionLayout 
                children={
                    <>
                        {
                            data
                            ?
                            <Stack>
                                <Box
                                    sx={{
                                        px: '5%'
                                    }}
                                >
                                    <BlogDetailsHero 
                                        id={id}
                                        title={data.title}
                                        description={data.description}
                                        intro={data.introduction}
                                    />

                                    <BlogDetailsBody subSections={data.subHeadings}/>

                                    <BlogAuthor author={data.author}/>

                                    <BlogCallToAction details={data.callToAction}/>

                                    <BlogRecommendations selectedId={id}/>
                                </Box>
                            </Stack>
                            :
                            <>
                                {
                                    error
                                    ?
                                    <FileNotFound 
                                        icon="/images/icons/no-file.png"
                                        description={t(`${blogLocales}.notFound.message`)}
                                        actionText={t(`${blogLocales}.notFound.action`)}
                                        navigateLink='/blog'
                                    />
                                    :
                                    <></>
                                }
                            </>
                        }
                    </>
                }
            />

            <FooterLayout />
        </>
    );
}

export default BlogDetailsLayout;